import { LOGOUT, SIGNUP_ROUTE } from "_constants";
import { getSuccessActionType } from "_helpers";
import ContainerButton from "_lib/ContainerButton";
import { store } from "_redux/store";
import { Flex, Modal, Typography } from "antd";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";

const CreateAccountConfirmModalContent = ({ message: apiMessage, onClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme?.palette?.background?.auth === "#16283A";

  const onConfirmCreateAccount = useCallback(() => {
    store.dispatch({ type: getSuccessActionType(LOGOUT) });
    navigate(SIGNUP_ROUTE, { replace: true });
    if (onClose) {
      onClose();
    } else {
      Modal.destroyAll();
    }
  }, [navigate, onClose]);

  const onCancelCreateAccount = useCallback(() => {
    store.dispatch({ type: getSuccessActionType(LOGOUT) });
    if (onClose) {
      onClose();
    } else {
      Modal.destroyAll();
    }
  }, [onClose]);

  return (
    <Flex vertical gap={10}>
      <Text style={{ color: isDark ? "#ffffff" : "#000000" }}>
        You don't have an account currently registered with us.{apiMessage ? ` ${apiMessage}` : ""}
      </Text>
      <Flex justify="end" gap={8}>
        <ContainerButton
          size="middle"
          title="Cancel"
          onClick={onCancelCreateAccount}
        />
        <ContainerButton
          size="middle"
          title="Proceed"
          type="primary"
          onClick={onConfirmCreateAccount}
        />
      </Flex>
    </Flex>
  );
};

const { Text } = Typography;

export default CreateAccountConfirmModalContent;
